var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('img',{staticClass:"rounded",class:_vm.rounded,attrs:{"src":_vm.src}}):_c('div',{staticClass:" bg-gray-500 rounded",class:_vm.rounded})}
var staticRenderFns = []

export { render, staticRenderFns }